import {
  ADD_USER_TAG_OPTION,
  GET_USER_TAG_OPTIONS,
  DELETE_USER_TAG_OPTION,
  DELETE_USER_TAG_TRANSLATION,
  UPDATE_USER_TAG_OPTION,
  UPDATE_USER_TAG_TRANSLATION,
  setUserTagOptionsError,
  setNewUserTagOption,
  removeUserTagOption,
  setUserTagOptionsProcessing,
  setUserTagOptions,
  ADD_USER_TAG_OPTION_TRANSLATION,
} from './actions'
import {
  _deleteUserTagOption,
  _deleteUserTagTranslation,
  _getUserTagOptions,
  _postUserTagOption,
  _postUserTagOptionTranslation,
  _putUserTagOption,
  _putUserTagTranslation,
} from '..'

const log = console

async function addUserTagOption ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action
  const { tag, category, translations } = payload
  try {
    store.dispatch(setUserTagOptionsProcessing({ data: true }))
    const options = {
      server: config.getIn(['data', 'servers', 'brooklyn']),
      translations,
      category,
      auth,
      tag,
    }

    const result = await _postUserTagOption(options)
    store.dispatch(setNewUserTagOption({
      data: result,
    }))
  } catch (error) {
    log.error(error, 'Error adding new tag.')
    store.dispatch(setUserTagOptionsError({
      error,
    }))
  }
}
async function addUserTagOptionTranslation ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action
  const { code, value, userTagsOptionsId } = payload
  try {
    store.dispatch(setUserTagOptionsProcessing({ data: true }))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      code,
      value,
      userTagsOptionsId,
    }

    const result = await _postUserTagOptionTranslation(options)
    if (result) {
      const allTags = await _getUserTagOptions(options)
      store.dispatch(setUserTagOptions({
        data: allTags,
      }))
    }
  } catch (error) {
    log.error(error, 'Error adding new tag.')
    store.dispatch(setUserTagOptionsError({
      error,
    }))
  }
}

async function getUserTagOptions ({ store }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUserTagOptionsProcessing({ data: true }))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
    }

    const results = await _getUserTagOptions(options)
    store.dispatch(setUserTagOptions({
      data: results,
    }))
  } catch (error) {
    log.error(error, 'Error getting tags.')
    store.dispatch(setUserTagOptionsError({
      error,
    }))
  }
}

async function deleteUserTagOption ({ store, action }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUserTagOptionsProcessing({ data: true }))
    const { payload } = action
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      id: payload,
    }

    await _deleteUserTagOption(options)
    store.dispatch(removeUserTagOption({
      data: payload,
    }))
  } catch (error) {
    log.error(error, 'Error getting tags.')
    store.dispatch(setUserTagOptionsError({
      error,
    }))
  }
}

async function deleteUserTagTranslation ({ store, action }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setUserTagOptionsProcessing({ data: true }))
    const { payload } = action
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      id: payload,
    }

    await _deleteUserTagTranslation(options)
    const results = await _getUserTagOptions(options)
    store.dispatch(setUserTagOptions({
      data: results,
    }))
  } catch (error) {
    log.error(error, 'Error getting tags.')
    store.dispatch(setUserTagOptionsError({
      error,
    }))
  }
}

async function updateUserTagOption ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action
  const { id, tag, category } = payload
  try {
    store.dispatch(setUserTagOptionsProcessing({ data: true }))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      tag,
      category,
      id,
    }

    const results = await _putUserTagOption(options)
    store.dispatch(setUserTagOptions({
      data: results,
    }))
  } catch (error) {
    log.error(error, 'Error updating tag.')
    store.dispatch(setUserTagOptionsError({
      error,
    }))
  }
}

async function updateUserTagTranslation ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action
  const { id, code, value } = payload
  try {
    store.dispatch(setUserTagOptionsProcessing({ data: true }))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      code,
      value,
      id,
    }

    await _putUserTagTranslation(options)
    const allTags = await _getUserTagOptions(options)
    store.dispatch(setUserTagOptions({
      data: allTags,
    }))
  } catch (error) {
    log.error(error, 'Error updating tag.')
    store.dispatch(setUserTagOptionsError({
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case ADD_USER_TAG_OPTION:
      addUserTagOption({ store, action })
      break
    case ADD_USER_TAG_OPTION_TRANSLATION:
      addUserTagOptionTranslation({ store, action })
      break
    case DELETE_USER_TAG_OPTION:
      deleteUserTagOption({ store, action })
      break
    case DELETE_USER_TAG_TRANSLATION:
      deleteUserTagTranslation({ store, action })
      break
    case GET_USER_TAG_OPTIONS:
      getUserTagOptions({ store })
      break
    case UPDATE_USER_TAG_OPTION:
      updateUserTagOption({ store, action })
      break
    case UPDATE_USER_TAG_TRANSLATION:
      updateUserTagTranslation({ store, action })
      break
    default:
      break
  }
  next(action)
}
